<div id='mathlive' class="math-field"  #mathField></div>
<!--<div [attr.hidden]="!isLocked ? true : undefined" class="math-field">{{this.getValue()}}</div>-->


